<template>
  <el-button
    size="mini"
    @click="childclick"
    icon="el-icon-delete"
    type="danger"
  >
    <slot>删除</slot>
  </el-button>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    childclick() {
       this.$emit('click');
      //  this.$confirm('您确定要删除当前选项?', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(()=>{
      //     this.$emit('click');
      //   }).catch(()=>{
      //     this.$message({
      //       type: 'info',
      //       message: '已取消删除'
      //     });
      //   });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>